export default __webpack_public_path__ + "static/feedback_avatar3-fafa093b5f4f9dd7181ad7e8c48ee5bd.webp";